<template>
  <div>
    <v-dialog v-model="mostrarFormularioObservacionesRepresentante" persistent max-width="80%">
      <v-form v-model="validFormularioRepresentante">
        <v-card>
          <v-card-text>
            <div>
              <h4 class="headline mb-0">GESTIÓN DE REPRESENTANTE</h4>
            </div>

            <v-divider class="mx-1"></v-divider>

            <v-alert
              :value="true"
              type="info"
              class="text-justify"
            >A continuación, usted puede hacer observaciones sobre el contenido de las versiones voluntarias rendidas por los comparecientes que fueron citados en el marco del Caso No. 01.</v-alert>

            <v-divider class="mx-1"></v-divider>

            <label>Presente a continuación las observaciones sobre el Paquete documental de Traslado del Caso No. 01: (por favor, inclúyalas enumeradas y especifique, de ser relevante, el documento o video al que hace referencia, el compareciente y la afirmación qa la cual observa.)</label>
            <section class="my-5 section-preview">
              <v-textarea
                v-if="editedItem.data"
                v-model="editedItem.data.bloque.traslado[0].observaciones"
                label="Observaciones:"
                hint="Brinde por favor las observaciones necesarias."
                :counter="3500"
                :rules="textRules"
                :error-messages="errors.collect(`${validCampoObservaciones}`)"
                required
              ></v-textarea>
            </section>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="red darken-1"
              text
              @click="mostrarFormularioObservacionesRepresentante = false"
            >Cancelar</v-btn>
            <v-btn
              color="primary"
              @click.prevent="updateFormularioObservacionesRepresentante()"
              :disabled="!validFormularioRepresentante"
              v-if="boton_guardar"
            >Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="mostrarFormularioFechaDocumentosRepresentante" persistent max-width="50%">
      <v-card>
        <v-card-title class="headline text-uppercase">CONFIRMACIÓN LECTURA DE DOCUMENTOS</v-card-title>
        <v-card-text>Para continuar debe aceptar el inicio de la lectura de los documentos. A partir de la fecha tiene 20 días para ingresar las observaciones pertinentes.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            text
            @click="mostrarFormularioFechaDocumentosRepresentante = false"
          >Cancelar</v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="updateFormularioFechaDocumentosRepresentante()"
          >Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="mostrar_resultados" persistent>
      <v-card>
        <v-card-title class="headline text-uppercase">FORMULARIO DILIGENCIADO POR {{editedItem.data === undefined ? 'LA VICTIMA' : editedItem.data.name}} {{editedItem.data === undefined ? '' : `- ${editedItem.data.bloque.nombre}` }}</v-card-title>
        <v-card-text>
          <Respuestas></Respuestas>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success darken-1" text @click="descargarPdf()">Descargar PDF</v-btn>
          <v-btn color="red darken-1" text @click="mostrar_resultados = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-toolbar dark flat color="grey-lighten">
      <v-toolbar-title>Listado de personas representadas</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-spacer></v-spacer>
    </v-toolbar>

    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Buscar..."
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="tableData"
      :search="search"
      class="elevation-1"
      :loading="cargandoDatosTabla"
      :rows-per-page-items="rowsPerPageItems"
      :rows-per-page="10"
      loading-text="Cargando... Espero por favor"
    >
      <template slot="items" slot-scope="props">
        <td>{{ props.item.data.name }}</td>
        <td>{{ props.item.data.numeroDocumento }}</td>
        <td>{{ props.item.data.bloque.nombre }}</td>
        <td class="my-2 text-center">
          <v-icon
            large
            color="green accent-4"
            @click="verDocumentos(props.item)"
            v-if="props.item.data.bloque.traslado.length > 0 && props.item.data.bloque.traslado[0].respuestas.length > 0"
          >verified_user</v-icon>
          <v-icon large color="red accent-4" @click="verDocumentos(props.item)" v-else>verified_user</v-icon>
        </td>
        <td class="my-2 text-center">
          <v-icon
            large
            color="green accent-4"
            @click="gestionFormularioRepresentante(props.item)"
            v-if="props.item.data.bloque.traslado.length > 0 && props.item.data.bloque.traslado[0].observaciones"
          >verified_user</v-icon>
          <v-icon
            large
            color="red accent-4"
            @click="gestionFormularioRepresentante(props.item)"
            v-else
          >verified_user</v-icon>
        </td>
        <!-- <td class="my-2 text-center">
          <v-icon small class="done" @click="descargarPdf(props.item)">get_app</v-icon>
        </td> -->
      </template>
      <template slot="no-data">
        <v-btn color="primary" v-if="mostrarMensajeCarga" @click="initialize">Recargar</v-btn>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import VictimasRepresentante from "../../../services/VictimasRepresentante";
import Preguntas from "../../../services/Preguntas";
import Traslado from "../../../services/Traslado";
import Bloques from "../../../services/Bloques";
import { EventBus } from "../../../EventBus";
import Auth from "../../../Auth";

export default {
  data: () => ({
    cargandoDatosTabla: true,
    mostrarMensajeCarga: false,
    mostrarFormularioFechaDocumentosRepresentante: false,
    mostrar_resultados: false,
    parametros: {},
    usuario: {},
    stepF1: true,
    stepF2: true,
    stepF3: true,
    stepF4: true,
    f0: 1,
    f1: 1,
    f2: 1,
    f3: 1,
    f4: 1,
    mostrarPreguntasFaseI: false,
    mostrarPreguntasFaseII: false,
    mostrarPreguntasFaseIII: false,
    mostrarPreguntasFaseIV: false,
    mostrarFormularioObservacionesRepresentante: false,
    validFormularioRepresentante: false,
    validCampoObservaciones: false,
    bloques: [],
    preguntas: [],
    preguntasXBloque: [],
    personas: [],
    search: "",
    headers: [
      { text: "NOMBRE COMPLETO", value: "data.name" },
      { text: "NÚMERO DE IDENTIFICACIÓN", value: "data.numeroDocumento" },
      { text: "BLOQUE", value: "data.bloque.nombre" },
      {
        text: "FORMULARIO TRASLADO",
        value: "traslado",
        align: "center"
      },
      {
        text: "OBSERVACIONES",
        value: "observaciones",
        align: "center"
      },
      // {
      //   text: "ACCIONES",
      //   value: "acciones",
      //   sortable: false
      // }
    ],
    rowsPerPageItems: [10, 50, 100],
    // pagination: {
    //     rowsPerPage: 20
    // },
    boton_guardar: true,
    tableData: [],
    tableDataFiles: [],
    editedIndex: -1,
    editedItem: {
      id: "",
      name: "",
      numeroDocumento: "",
      created_at: ""
    },
    defaultItem: {
      id: "",
      name: "",
      numeroDocumento: "",
      created_at: ""
    },
    textRules: [
      v => !!v || "Campo es requerido",
      v => (v && v.length <= 3500) || "Campo no mayor a 500 caracteres"
    ]
  }),
  mounted() {
    this.initialize();
  },
  created() {},
  methods: {
    initialize() {
      this.usuario = { ...user.representante };
      VictimasRepresentante.getVictimasRepresentante(this.usuario).then(
        response => {
          let datosTrasformados = this.trasformarDatos(response.data);
          this.tableData = datosTrasformados;
          this.cargandoDatosTabla = false;
          if (!this.tableData.length) {
            this.mostrarMensajeCarga = true;
          }
        }
      );
    },
    obtenerDatosTraslado(data, bloque, i) {
      return data[i].traslados.filter(objeto => objeto.bloque_id === bloque);
    },
    validarDatosTraslado(data, bloque, i) {
      let objeto = this.obtenerDatosTraslado(data, bloque, i);
      if (!objeto.length) {
        objeto = [];
        objeto.push({
          fecha_lectura_documentos: "",
          observaciones: "",
          respuestas: []
        });
      }
      return objeto;
    },
    verDocumentos(item) {
      this.editedIndex = this.tableData.indexOf(item);
      this.editedItem = Object.assign({}, item);

      // console.log("verDocumentos");
      // console.log(!item.data.bloque.traslado[0].fecha_lectura_documentos);
      if (!item.data.bloque.traslado[0].fecha_lectura_documentos) {
        this.mostrarFormularioFechaDocumentosRepresentante = true;
      } else {
        this.obtenerResultadoTraslado(item.data.id, item.data.bloque.id);
      }
    },
    obtenerResultadoTraslado(persona, bloque) {
      this.mostrar_resultados = true;
      this.parametros = {
        persona_id: persona,
        bloque_id: bloque,
        tipo_usuario: "representante",
        usuario_id: this.usuario.id
      };
      EventBus.$emit("parametros", this.parametros);
    },
    trasformarDatos(data) {
      let personas = [];

      let id = 0;
      for (let i = 0; i < data.length; i++) {
        for (let j = 0; j < data[i].bloques.length; j++) {
          personas.push({
            id: id++,
            data: {
              id: data[i].id,
              name: data[i].name,
              primer_nombre: data[i].primer_nombre,
              segundo_nombre: data[i].segundo_nombre,
              primer_apellido: data[i].primer_apellido,
              segundo_apellido: data[i].segundo_apellido,
              numeroDocumento: data[i].numeroDocumento,
              email: data[i].email,
              bloque: {
                id: data[i].bloques[j].id,
                nombre: data[i].bloques[j].nombre,
                traslado: this.validarDatosTraslado(
                  data,
                  data[i].bloques[j].id,
                  i
                )
              }
            }
          });
        }
      }
      return personas;
    },
    gestionFormularioRepresentante(item) {
      this.editedIndex = this.tableData.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.mostrarFormularioObservacionesRepresentante = true;
    },
    updateFormularioObservacionesRepresentante() {
      let persona_id = this.editedItem.data.id;
      let bloque_id = this.editedItem.data.bloque.id;
      let data = { ...this.editedItem, tipo_cambio: "observaciones" };
      axios
        .put(
          `/api/traslados/representante/actualizar/${this.usuario.id}/${persona_id}/${bloque_id}`,
          data
        )
        .then(response => {
          this.mostrarFormularioObservacionesRepresentante = false;
        });
    },
    updateFormularioFechaDocumentosRepresentante() {
      let persona_id = this.editedItem.data.id;
      let bloque_id = this.editedItem.data.bloque.id;
      let data = {
        ...this.editedItem,
        tipo_cambio: "fecha_lectura_documentos"
      };
      axios
        .put(
          `/api/traslados/representante/actualizar/${this.usuario.id}/${persona_id}/${bloque_id}`,
          data
        )
        .then(response => {
          this.mostrarFormularioFechaDocumentosRepresentante = false;
          this.obtenerResultadoTraslado(persona_id, bloque_id);
        });
    },
    //     descargarPdf() {
    //   let persona_id = this.usuario.id;
    //   let bloque_id = this.bloque_id;

    //   // this.show_export_spinner = true;

    //   let ruta = `/api/traslados/personas/${persona_id}/bloque/${bloque_id}/respuestas/pdf`;
    //   Traslado.getObtenerPDFResultadoTrasladoXBloque(persona_id, bloque_id)
    //     .then(response => {
    //       // this.show_export_spinner = false;

    //       const url = window.URL.createObjectURL(
    //         new Blob([response.data], { type: "application/pdf" })
    //       );

    //       const link = document.createElement("a");
    //       link.href = url;
    //       link.setAttribute("download", "formulario_traslado.pdf"); //or any other extension

    //       document.body.appendChild(link);
    //       link.click();
    //     })
    //     .catch(error => {
    //       console.log("Ha ocurrido un error en la exportación a PDF");
    //       this.show_export_spinner = false;
    //     });
    // },
    descargarPdf() {

      let persona_id = this.editedItem.data.id;
      let bloque_id = this.editedItem.data.bloque.id;

      this.show_export_spinner = true;

      let ruta = `/api/traslados/personas/${persona_id}/bloque/${bloque_id}/respuestas/pdf`;
      Traslado.getObtenerPDFResultadoTrasladoXBloque(persona_id, bloque_id)
        .then(response => {
          this.show_export_spinner = false;

          const url = window.URL.createObjectURL(
            new Blob([response.data], { type: "application/pdf" })
          );

          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "formulario_traslado.pdf"); //or any other extension

          document.body.appendChild(link);
          link.click();
        })
        .catch(error => {
          console.log("Ha ocurrido un error en la exportación a PDF");
          this.show_export_spinner = false;
        });
    }
  }
};
</script>  